import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Storage } from './cached-http.service';
import { Cache } from './cached-http.service';
import { CacheStorageService } from './cache-storage.service';
import { CacheInterceptorService, APP_MAX_EXPIRATION_TIME, CacheStorageLayer, IsOnlineService } from './interceptors/cache-interceptor.service';
import { ClearInterceptorService } from './interceptors/clear-interceptor.service';
import { TokenInterceptorService } from './interceptors/token-interceptor.service';
import { LangInterceptorService } from '../../../rulebook/lib/services/lang/lang-interceptor.service';
import { RulebookLevelInterceptorService } from 'src/app/common-page-components/interceptors/rulebook-level-interceptor.service';
import { FiltersAthleteGeneralService } from '../../../athlete/services/filters-athlete-general.service';
export enum DefaultStorageTypes {
  localStorage = 'localStorage'
}
export interface IOptionsModule {
  storageProvider: DefaultStorageTypes;
}
export function storageCache(storage: Storage) {
  return new Cache(storage);
}
@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [HttpClient,
    { provide: APP_MAX_EXPIRATION_TIME, useValue: 1800 },
    CacheStorageLayer,
    IsOnlineService,
    { provide: HTTP_INTERCEPTORS, useClass: RulebookLevelInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LangInterceptorService, multi:true},
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ClearInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptorService, multi: true }
  ],
  exports: []
})

export class ServicesModule {

  static forRoot(optionsModule?: IOptionsModule, customStorage?: Storage): ModuleWithProviders {
    let storageProvider: Storage
    if (optionsModule) {
      switch (optionsModule.storageProvider) {
        case DefaultStorageTypes.localStorage:
          storageProvider = new CacheStorageService();
          break;
        default:
          storageProvider = new CacheStorageService();
      }
    } else {
      if (customStorage === undefined) {
        storageProvider = new CacheStorageService();
      }
    }
    if (customStorage !== undefined) {
      storageProvider = customStorage;
    }
    return {
      ngModule: ServicesModule,
      providers: [{ provide: Cache, useFactory: storageCache, deps: [storageProvider] }],
    }
  }
}
